import * as React from 'react';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { ContactLensesBundleBeneluxSolutions } from '../../ContactLensesBundleBeneluxSolutions/layouts/ContactLensesBundleBeneluxSolutions.js';
import '@swc/helpers';
import '@grandvisionhq/common';
import '@grandvisionhq/icons';
import '@grandvisionhq/elements';
import { UpsellLayout } from '../components/UpsellLayout.js';
import { UpsellCategory } from '../layouts/UpsellCategory.js';
import { UpsellProducts } from '../layouts/UpsellProducts.js';

// FYI: Many of these labels haven't been implemented in Bloomreach yet
const productTypeSpecificMessageLabelMapping = {
    'contact-lenses-bundle-benelux': 'cart.notification.upsell.contactLensesBundleBenelux.message',
    'contact-lenses': 'cart.notification.upsell.contactLenses.message',
    'prescription-glasses': 'cart.notification.upsell.prescriptionGlasses.message',
    'non-prescription-bundle': 'cart.notification.upsell.nonRxBundle.message',
    frames: 'cart.notification.upsell.frames.message',
    solutions: 'cart.notification.upsell.solution.message',
    sunglasses: 'cart.notification.upsell.sunglasses.message',
    'ready-readers': 'cart.notification.upsell.readyReaders.message',
    accessories: 'cart.notification.upsell.accessories.message'
};
const ProductTypeMessages = ({ lineItemTypes  })=>{
    const { getLabel  } = useIntl();
    const messages = lineItemTypes.map((t)=>getLabel(productTypeSpecificMessageLabelMapping[t], {
            hideLabelKey: true
        })
    ).filter(Boolean);
    if (messages.length <= 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        className: "alert-m-default"
    }, [
        ...messages
    ]);
};
const UpsellContainer = ({ lineItems , products , recommendedCategoryKey , clbbProductSku ,  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            upsellCategoryHeading: getLabel('cart.notification.productAdded'),
            clbbCategoryHeading: getLabel('products.contactLenses.solutions.title')
        })
    , [
        getLabel
    ]);
    const lineItemTypes = [
        ...new Set(lineItems.map((l)=>l.productType
        ))
    ].filter(Boolean);
    if (clbbProductSku && lineItemTypes.some((type)=>type === 'contact-lenses-bundle-benelux'
    )) {
        return /*#__PURE__*/ React.createElement(UpsellLayout, {
            heading: labels.clbbCategoryHeading
        }, /*#__PURE__*/ React.createElement(ProductTypeMessages, {
            lineItemTypes: lineItemTypes
        }), /*#__PURE__*/ React.createElement(ContactLensesBundleBeneluxSolutions, {
            subscriptionProductSku: clbbProductSku
        }));
    }
    if (recommendedCategoryKey) {
        return /*#__PURE__*/ React.createElement(UpsellLayout, {
            heading: labels.upsellCategoryHeading
        }, /*#__PURE__*/ React.createElement(ProductTypeMessages, {
            lineItemTypes: lineItemTypes
        }), /*#__PURE__*/ React.createElement(UpsellCategory, {
            recommendedCategoryKey: recommendedCategoryKey
        }));
    }
    if (products) {
        return /*#__PURE__*/ React.createElement(UpsellLayout, {
            heading: labels.upsellCategoryHeading
        }, /*#__PURE__*/ React.createElement(ProductTypeMessages, {
            lineItemTypes: lineItemTypes
        }), /*#__PURE__*/ React.createElement(UpsellProducts, {
            products: products
        }));
    }
    return null;
};

export { UpsellContainer };
//# sourceMappingURL=UpsellContainer.js.map
